<script>

export default {
    props: ['adressenErgebnis', 'adressenSerien'],
    data()
    {
        return {}
    },

    map: null,  // non-reactive
    /** @type {google.maps.InfoWindow} */
    infoWindow: null,  // non-reactive

    mounted()
    {
        let mapStyles = [
            {
                stylers: [
                    {hue: "#000000"},
                    // grau
                    {saturation: -100},
                    // Helligkeit
                    {lightness: -5}
                ]
            },
            {
                // diese Angaben sind nicht nötig, nur für Demozwecke
                featureType: "road",
                elementType: "geometry",
                stylers    : [
                    {visibility: "simplified"}
                ]
            },
            {
                featureType: "road",
                elementType: "labels",
                stylers    : [
                    {visibility: "on"}
                ]
            }
        ];

        let mapOptions = {
            // zoom und center müssen immer definiert sein: https://stackoverflow.com/a/32142513/4576064
            zoom     : 12,
            center   : {lat: 51.382803, lng: 8.998488},
            mapTypeId: window.google.maps.MapTypeId.ROADMAP,
            // panControl        : false,
            // zoomControl       : true,
            // mapTypeControl    : false,
            // scaleControl      : false,
            // streetViewControl : false,
            // overviewMapControl: false,
            styles: mapStyles
        };

        // Boolean(this.app.config.globalProperties.window.google) &&
        this.$options.map = new window.google.maps.Map(document.getElementById('googlemap-canvas'), mapOptions);

        this.$options.infoWindow = new window.google.maps.InfoWindow();

        this.setMarkers();
    },

    methods: {
        setMarkers()
        {
            let boundszaehler = 0;
            let bounds = new window.google.maps.LatLngBounds();
            let lastLatLng = null;

            let markerImage = new window.google.maps.MarkerImage('/static/img/gmap-pin.png',
                new window.google.maps.Size(42, 42),   // Markergröße
                new window.google.maps.Point(0, 0),    // der Usprung
                new window.google.maps.Point(21, 21)); // der Mittelpunkt

            for(let adresse of this.adressenErgebnis) {
                // console.log(adresse);
                let latlng = new window.google.maps.LatLng(adresse.lat, adresse.lon);
                lastLatLng = latlng;
                bounds.extend(latlng);
                boundszaehler++;

                let marker = new window.google.maps.Marker({
                    position: latlng,
                    map     : this.$options.map,
                    icon    : markerImage,
                    title   : adresse.name
                });

                // Infowindow-HTML mit Twig gerendert
                marker.infowindowContent = adresse.adresse_infowindow_html;

                marker.addListener('click', () =>
                {
                    this.handleClickMarker(marker);
                });
            }

            if(boundszaehler > 1) {
                this.$options.map.fitBounds(bounds);
            } else if(boundszaehler === 1) {
                if(lastLatLng !== null) {
                    this.$options.map.setCenter(lastLatLng);
                }
            }
        },

        handleClickMarker(marker)
        {
            this.$options.infoWindow.setContent(marker.infowindowContent);
            this.$options.infoWindow.open(this.$options.map, marker);
        }
    }
}
</script>

<template>

    <div id="googlemap-canvas" class="karte"></div>

</template>
